// This icon file is generated automatically.
var PFolderAddOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M6.56 5.92v1.33H5.24c-.06 0-.12.05-.12.1v.67c0 .05.06.1.12.1h1.32v1.33c0 .06.05.11.11.11h.66c.06 0 .1-.05.1-.1V8.11h1.33c.06 0 .12-.04.12-.1v-.66c0-.06-.06-.11-.12-.11H7.44V5.92a.11.11 0 00-.11-.1h-.66c-.06 0-.1.04-.1.1zm6.19-2.26h-5.6L5.3 1.91a.13.13 0 00-.09-.03H1.25a.5.5 0 00-.5.5v9.25c0 .27.22.5.5.5h11.5a.5.5 0 00.5-.5V4.16a.5.5 0 00-.5-.5zM12.12 11H1.88V3h2.94l1.87 1.79h5.43V11z", "fill-rule": "nonzero" } }] }, "name": "p-folder-add", "theme": "outlined" };
export default PFolderAddOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PFolderAddOutlined.js
// module id = 3416
// module chunks = 0